import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useLang } from '../context/LangContext';
import PopupAd from '../components/PopupAd';
// 导入model图片
import model1 from '../assets/images/client1.jpg';
import model2 from '../assets/images/client2.jpg';
import model3 from '../assets/images/client3.jpg';
import cmodel1 from '../assets/images/cmodel1.jpg';
import cmodel2 from '../assets/images/skin.jpg';
import cmodel3 from '../assets/images/bodyshaping2.jpg';

const content = {
  en: {
    heroTitle: "Crafting natural beauty with gentle precision.",
    heroSubtitle: "",
    heroBtn: "Book Now",
    servicesTitle: "Our Services",
    services: [
      {
        id: 1,
        title: "Injection Beauty",
        description: "Professional injection beauty services to rejuvenate your youthful glow.",
        image: cmodel1,
        cardType: 'individual',
      },
      {
        id: 2,
        title: "Skin Care",
        description: "Customized skin care solutions to improve your skin problems.",
        image: cmodel2,
        cardType: 'couples',
      },
      {
        id: 3,
        title: "Body Shaping",
        description: "Scientific body shaping plans to create a perfect figure.",
        image: cmodel3,
        cardType: 'teen',
      },
    ],
    learnMore: "Learn More →",
    testimonialsTitle: "Testimonials",
    testimonials: [
      {
        id: 1,
        name: "Linlin_Z",
        content: "The service is very professional, the effect is obvious, and the doctor patiently answered my questions.",
        rating: 5,
        image: model1,
      },
      {
        id: 2,
        name: "ErikaPlaya",
        content: "The environment is great, the service attitude is excellent, and the results exceeded expectations.",
        rating: 5,
        image: model2,
      },
      {
        id: 3,
        name: "HubPlant",
        content: "The doctor is very professional, the whole process is comfortable, and I am very satisfied.",
        rating: 5,
        image: model3,
      },
    ],
    ctaTitle: "Start Your Beauty Journey",
    ctaBtn: "Book Now",
  },
  cn: {
    heroTitle: "Crafting natural beauty with gentle precision.",
    heroSubtitle: "",
    heroBtn: "立即预约",
    servicesTitle: "我们的服务",
    services: [
      {
        id: 1,
        title: "注射美容",
        description: "专业注射美容服务，让您焕发青春光彩",
        image: cmodel1,
        cardType: 'individual',
      },
      {
        id: 2,
        title: "皮肤护理",
        description: "定制化皮肤护理方案，改善肤质问题",
        image: cmodel2,
        cardType: 'couples',
      },
      {
        id: 3,
        title: "身体塑形",
        description: "科学塑形方案，打造完美身材",
        image: cmodel3,
        cardType: 'teen',
      },
    ],
    learnMore: "了解更多 →",
    testimonialsTitle: "客户评价",
    testimonials: [
      {
        id: 1,
        name: "Linlin_Z",
        content: "服务非常专业，效果显著，医生很耐心解答我的问题。",
        rating: 5,
        image: model1,
      },
      {
        id: 2,
        name: "ErikaPlaya",
        content: "环境很好，服务态度很棒，效果超出预期。",
        rating: 5,
        image: model2,
      },
      {
        id: 3,
        name: "HubPlant",
        content: "医生很专业，整个过程很舒适，非常满意。",
        rating: 5,
        image: model3,
      },
    ],
    ctaTitle: "开启您的美丽之旅",
    ctaBtn: "立即预约",
  }
};

const Home = () => {
  const { lang } = useLang();
  const c = content[lang];
  const videoRef = useRef(null);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    // 确保移动端自动播放：必须静音，并主动调用 play()
    v.muted = true;
    const tryPlay = async () => {
      try {
        await v.play();
      } catch (_err) {
        // 某些浏览器可能仍然阻止自动播放，保持静音与行内播放即可
      }
    };
    // 如果已暂停则尝试播放
    if (v.paused) {
      tryPlay();
    }
  }, []);

  // JSON-LD Structured Data for Home Page
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    "@id": "https://www.haloaestheticclinic.com/#organization",
    "name": "Halo Aesthetic Clinic",
    "url": "https://www.haloaestheticclinic.com",
    "image": "https://www.haloaestheticclinic.com/logo.jpg",
    "logo": {
      "@type": "ImageObject",
      "url": "https://www.haloaestheticclinic.com/logo.jpg"
    },
    "telephone": "+14377555409",
    "email": "info@haloaestheticclinic.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "1595 16th Ave Suite 103",
      "addressLocality": "Richmond Hill",
      "addressRegion": "ON",
      "postalCode": "L4B 3N9",
      "addressCountry": "CA"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Tuesday",
        "opens": "11:00",
        "closes": "19:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Wednesday",
        "opens": "11:00",
        "closes": "19:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Thursday",
        "opens": "11:00",
        "closes": "19:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Friday",
        "opens": "13:00",
        "closes": "21:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "11:00",
        "closes": "19:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Sunday",
        "opens": "11:00",
        "closes": "19:00"
      }
    ],
    "priceRange": "$$",
    "areaServed": {
      "@type": "City",
      "name": "Richmond Hill"
    },
    "medicalSpecialty": "Dermatology"
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://www.haloaestheticclinic.com/#organization",
    "name": "Halo Aesthetic Clinic",
    "url": "https://www.haloaestheticclinic.com",
    "logo": {
      "@type": "ImageObject",
      "url": "https://www.haloaestheticclinic.com/logo.jpg"
    },
    "sameAs": [
      "https://www.facebook.com/haloaestheticclinic",
      "https://www.instagram.com/haloaestheticclinic"
    ]
  };

  return (
    <>
      <Helmet>
        <title>Halo Aesthetic Clinic - Professional Medical Aesthetics in Richmond Hill</title>
        <meta name="description" content="Halo Aesthetic Clinic offers professional medical aesthetics services in Richmond Hill, ON. Specializing in injectable treatments, advanced skincare, and body contouring." />
        <link rel="canonical" href="https://www.haloaestheticclinic.com/" />
        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(localBusinessSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
        {/* Event snippet for 网页浏览 conversion page
In your html page, add the snippet and call gtag_report_conversion when someone clicks on the chosen link or button. */}
        <script>
          {`function gtag_report_conversion(url) {
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
      'send_to': 'AW-18458381832/6SnuCPThvpcdEIic0uFE',
      'value': 1.0,
      'currency': 'CAD',
      'event_callback': callback
  });
  return false;
}`}
        </script>
      </Helmet>
      <div className="bg-softGradient bg-no-repeat bg-top text-text">
        <PopupAd delay={2000} />
      {/* Background Video fixed behind navbar and hero */}
      <div className="pointer-events-none fixed inset-x-0 top-0 h-[78vh] -z-10">
        <video
          ref={videoRef}
          className="absolute inset-0 w-full h-full object-cover"
          src="/videos/clinic.mp4"
          autoPlay
          loop
          muted
          playsInline
          webkit-playsinline="true"
          x5-playsinline="true"
          preload="auto"
          controls={false}
        />
        <div className="absolute inset-0 bg-champagne/35" />
      </div>
      {/* Hero content over the fixed video */}
      <section className="relative w-full h-[60vh] md:h-[72vh] flex items-center justify-center px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl text-center drop-shadow">
          <h1 className={`text-3xl md:text-5xl text-black whitespace-pre-line handwrite font-hero-ultrathin font-hero-en`}>{c.heroTitle}</h1>
          {lang === 'cn' && (
            <p className="mt-4 text-[1.05rem] md:text-[1.2rem] text-black font-hero-en">
              以尖端科技和成熟技术铸就自然之美，你的期待在这里皆被温柔相待
            </p>
          )}
          <div className="mt-10">
            <Link
              to="/book-form"
              className="px-4 py-2 rounded-xl shadow-soft transition-all text-gray-900 hover:shadow-glow hover:brightness-110 border border-champagne/60"
              style={{
                backgroundImage:
                  'linear-gradient(90deg, rgba(217,195,169,1) 0%, rgba(217,195,169,0.8) 40%, rgba(217,195,169,0.3) 100%)'
              }}
            >
              {c.heroBtn}
            </Link>
          </div>
        </div>
      </section>
      {/* Hero Section merged into video above */}

      {/* Services Section - Category Cards */}
      <section className="py-section max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-h2 font-bold text-text mb-large text-center">{c.servicesTitle}</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {c.services.map((service) => (
            <div
              key={service.id}
              className={`bg-white/70 backdrop-blur-sm rounded-xl shadow-card p-medium text-left flex flex-col items-start border border-champagne/40 hover:shadow-glow transition-all duration-300 group`}
            >
              <div className="mb-medium">
                <h3 className="text-h2 font-bold text-gray-900">{service.title}</h3>
              </div>
              <div className="w-full h-40 rounded-md mb-medium overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-[450ms] group-hover:scale-105"
                />
              </div>
              <p className="text-small text-text-secondary mb-small">{service.description}</p>
              <Link
                to={`/services#${service.id}`}
                className="text-contrastgreen font-bold text-link flex items-center mt-auto hover:underline"
              >
                {c.learnMore} <span className="ml-1">→</span>
              </Link>
            </div>
          ))}
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-section bg-softGradient">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-h2 font-bold text-text mb-large text-center">{c.testimonialsTitle}</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {c.testimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                className="bg-white/80 backdrop-blur-sm p-medium rounded-xl shadow-card flex flex-col items-start border border-champagne/40"
              >
                <div className="flex items-center mb-4">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full object-cover mr-3"
                  />
                  <div className="flex items-center">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <svg
                        key={i}
                        className="w-5 h-5 text-softGold"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                    ))}
                  </div>
                </div>
                <p className="text-text-secondary text-small mb-small">{testimonial.content}</p>
                <p className="font-semibold text-text">{testimonial.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-section bg-softRadial">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-h2 font-bold text-text mb-large">{c.ctaTitle}</h2>
          <Link
            to="/book-form"
            className="px-4 py-2 rounded-xl shadow-soft transition-all text-gray-900 hover:shadow-glow hover:brightness-110 border border-champagne/60"
            style={{
              backgroundImage:
                'linear-gradient(90deg, rgba(217,195,169,1) 0%, rgba(217,195,169,0.8) 40%, rgba(217,195,169,0.3) 100%)'
            }}
          >
            {c.ctaBtn}
          </Link>
        </div>
      </section>
      </div>
    </>
  );
};

export default Home; 